export default {
      id: "group-on-map-usage",
      viewBox: "0 0 25 23",
      url: __webpack_public_path__ + "img/icons.svg#group-on-map",
      toString: function () {
        return this.url;
      }
    }